
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/fact-sheets",
      function () {
        return require("private-next-pages/fact-sheets/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/fact-sheets"])
      });
    }
  